<template>
  <div class="youngs-pro-fixed">
    <div class="viz-header-compact" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex>$Δx = (L/d) · λ$</div>
    </div>

    <div class="main-layout vertical">
      <div class="simulation-stage dark-stage">
        <div class="hud-panel">
          <div class="hud-item cyan">
            <label>波长 λ</label>
            <span class="val">{{ lambda.toFixed(0) }} <small>nm</small></span>
          </div>
          <div class="hud-item orange">
            <label>双缝间距 d</label>
            <span class="val">{{ d.toFixed(2) }} <small>mm</small></span>
          </div>
          <div class="hud-item green">
             <label>实测条纹间距 Δx</label>
             <span class="val">{{ deltaX.toFixed(2) }} <small>mm</small></span>
          </div>
        </div>

        <svg width="100%" height="240" viewBox="0 0 450 240" preserveAspectRatio="xMidYMid meet">
          <!-- 远端观测屏幕 (Observation Screen) -->
          <rect x="380" y="20" width="40" height="200" fill="#0f172a" stroke="#334155" />
          
          <!-- 干涉条纹模拟 (Interference Fringes) -->
          <g v-for="i in 15" :key="i">
             <rect x="385" :y="120 + (i-8)*deltaX_visual - 3" width="30" height="6" :fill="waveColor" :opacity="getFringeOpacity(i)" />
          </g>

          <!-- 双缝结构 (Double Slits) -->
          <line x1="100" y1="20" x2="100" y2="120 - d*5" stroke="#94a3b8" stroke-width="4" />
          <line x1="100" :y1="120 - d*5 + 2" :x2="100" :y2="120 + d*5 - 2" stroke="#94a3b8" stroke-width="4" />
          <line x1="100" :y1="120 + d*5" x2="100" y2="220" stroke="#94a3b8" stroke-width="4" />

          <!-- 发出的波阵面 (Simplified Rays) -->
          <g v-for="p in [1, -1]" :key="'p'+p">
             <line x1="40" y1="120" x2="100" :y2="120 + p*d*5" stroke="#fbbf24" stroke-width="1.5" opacity="0.3" stroke-dasharray="2,2" />
          </g>

          <text x="350" y="215" text-anchor="end" fill="#334155" font-size="10">屏 L = {{ screenL }} cm (固定)</text>
        </svg>

        <div class="physics-caption">
           结论：条纹间距 $\Delta x$ 与波长 $\lambda$、屏距 $L$ 成正比，与双缝间距 $d$ 成反比。
        </div>
      </div>

      <div class="compact-controls">
        <div class="control-card">
           <div class="flex-row items-center gap-6">
              <div class="flex-1">
                 <label class="s-label">调节波长 λ (红长蓝短)：{{ lambda }} nm</label>
                 <el-slider v-model="lambda" :min="400" :max="750" size="small"></el-slider>
              </div>
              <div class="flex-1">
                 <label class="s-label">调节双缝间距 d (愈窄愈宽)：{{ d }} mm</label>
                 <el-slider v-model="d" :min="0.1" :max="0.5" :step="0.01" size="small"></el-slider>
              </div>
           </div>
        </div>
        
        <!-- 原子专业高对比度卡片 -->
        <div class="discovery-card-discovery-tir" v-latex>
           <div class="icon-wrap"><i class="el-icon-view"></i></div>
           <div class="text-content">
             <p><strong>实战物理：</strong>杨氏双缝是波动光学的奠基实验。<strong>解惑：</strong>为什么条纹那么细？<strong>观察：</strong>调节红色光（长波长），你会发现条纹间距立刻变大（变稀疏）；调节缝距 $d$，缝越窄，条纹推得越开。这就是光的“波动性”被量化的瞬间，公式里的比例关系在屏幕上活生生地呈现出来了。
             </p>
           </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { props: { knowledgePoint: String },
  name: 'YoungsDoubleSlitProViz',
  data() {
    return {
      lambda: 632, // He-Ne Laser typical
      d: 0.25,
      screenL: 100 // Constant for now
    }
  },
  computed: {
    deltaX() {
       // DeltaX = (L/d)*lambda. Using scaled units for visual.
       return (this.screenL / (this.d * 10)) * (this.lambda / 1000);
    },
    deltaX_visual() {
       return this.deltaX * 30; // Scale factor for SVG height
    },
    waveColor() {
       if (this.lambda < 450) return "#7c3aed";
       if (this.lambda < 500) return "#3b82f6";
       if (this.lambda < 570) return "#10b981";
       if (this.lambda < 620) return "#fbbf24";
       return "#dc2626";
    }
  },
  methods: {
    getFringeOpacity(i) {
       // Sinc function mock: intensity falls off from center
       const normalized = Math.abs(i - 8) / 8;
       return 1 - normalized * 0.8;
    }
  }
}
</script>

<style scoped lang="scss">
@import "./PhysicsCommon.scss";
.youngs-pro-fixed { flex: 1; display: flex; flex-direction: column; gap: 8px; height: 100%; overflow: hidden; }
</style>
